import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDayClearSky: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M50.0056 68.2272C60.0696 68.2272 68.228 60.0688 68.228 50.0048C68.228 39.9409 60.0696 31.7824 50.0056 31.7824C39.9417 31.7824 31.7832 39.9409 31.7832 50.0048C31.7832 60.0688 39.9417 68.2272 50.0056 68.2272Z"
        fill="#F9D23E"
      />
      <path d="M52.2841 13.56H47.7285V27.2268H52.2841V13.56Z" fill="#F9D23E" />
      <path
        d="M25.8487 22.6253L22.627 25.8461L32.2894 35.5113L35.5111 32.2905L25.8487 22.6253Z"
        fill="#F9D23E"
      />
      <path
        d="M27.2274 47.727H13.5605V52.2826H27.2274V47.727Z"
        fill="#F9D23E"
      />
      <path
        d="M32.2888 64.5004L22.625 74.1642L25.8463 77.3855L35.5101 67.7217L32.2888 64.5004Z"
        fill="#F9D23E"
      />
      <path
        d="M52.2841 72.7829H47.7285V86.4497H52.2841V72.7829Z"
        fill="#F9D23E"
      />
      <path
        d="M67.7237 64.5037L64.502 67.7245L74.1644 77.3897L77.3861 74.1689L67.7237 64.5037Z"
        fill="#F9D23E"
      />
      <path d="M86.452 47.727H72.7852V52.2826H86.452V47.727Z" fill="#F9D23E" />
      <path
        d="M74.1658 22.6267L64.502 32.2905L67.7232 35.5118L77.387 25.848L74.1658 22.6267Z"
        fill="#F9D23E"
      />
    </svg>
  )
}

export default WeatherIconDayClearSky
